import React, { Component } from 'react';

import HeaderTop from '../header-top/HeaderTop';
import HeaderBottom from '../header-bottom/HeaderBottom';
import './style.css';


export default class Header extends Component {
  state = {
    isFixed: false
  };

  componentDidMount() {
    if (window.pageYOffset > this.refs.headerTop.refs.topContainer.clientHeight) {
      this.setState({isFixed: true});
    }

    let that = this;
    window.onscroll = () => {
      if (window.pageYOffset > this.refs.headerTop.refs.topContainer.clientHeight) {
        that.setState({isFixed: true});
      } else {
        that.setState({isFixed: false});
      }
    }
  }

  render() {
    return (
      <div className='header'>
        <HeaderTop ref='headerTop'/>
        <HeaderBottom fixed={this.state.isFixed} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/layout-page/blocks/header/Header.js